import {
  QueryFunction, QueryKey, UseQueryOptions, UseQueryResult, useQuery,
} from '@tanstack/react-query';

export type QueryWithInitialDataFn = <TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData>(
  queryKey: QueryKey,
  queryFn: QueryFunction<TQueryFnData>,
  initial: TData | undefined,
  options?: Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey' | 'queryFn'>) =>
  UseQueryResult<TData, TError> & { current?: TData, hasFreshData: boolean };

export const useQueryWithInitialValue = <TQueryFnData = unknown, TError = unknown,
    TData = TQueryFnData>(
    queryKey: QueryKey,
    queryFn: QueryFunction<TQueryFnData>,
    initial: TQueryFnData,
    options?: Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey' | 'queryFn'>,
  ) => {
  const queryData = useQuery<TQueryFnData, TError, TData>({
    queryKey,
    queryFn,
    ...options,
  });
  // If there is data or error, we are fine with showing
  const hasFreshData = !!queryData.data || !!queryData.error;
  const current = queryData.data || initial;
  return { ...queryData, current, hasFreshData };
};
